/* eslint-disable */
import Vue from "vue";
import Vuex from "vuex";

import prodotti from "./prodotti";
import clienti from "./clienti";
import movimenti from "./movimenti";
import movimentiDettaglio from "./movimentiDettaglio";
import documenti from "./documenti";
import documentiDettaglio from "./documentiDettaglio";
import utenti from "./utenti";
import magazzini from "./magazzini";
import totem from "./totem";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    prodotti,
    clienti,
    movimenti,
    movimentiDettaglio,
    documenti,
    documentiDettaglio,
    utenti,
    magazzini,
    totem,
  },
  state: {
    leftDrawer: false,
    rightDrawer: false,
    hideRightDrawer: false,
    rightDrawerReadOnly: false,
    token: "",
    moduliLicenza: [],
    utente: "",
  },
  getters: {
    leftDrawer: (state) => state.leftDrawer,
    rightDrawer: (state) => state.rightDrawer,
    hideRightDrawer: (state) => state.hideRightDrawer,
    rightDrawerReadOnly: (state) => state.rightDrawerReadOnly,
    token: (state) => state.token,
    moduliLicenza: (state) => state.moduliLicenza,
    localModuliLicenza: (state) => {
      const bb = localStorage.getItem("moduli");
      const moduli = bb ? Buffer.from(bb, "base64").toString("ascii") : "";
      return JSON.parse(moduli);
    },
    utente: (state) => state.utente,
  },
  mutations: {
    SET_LEFT_DRAWER(state, value) {
      state.leftDrawer = value;
    },
    SET_RIGHT_DRAWER(state, value) {
      state.rightDrawer = value;
    },
    HIDE_RIGHT_DRAWER(state, value) {
      state.hideRightDrawer = value;
    },
    SET_RIGHT_DRAWER_READ_ONLY(state, value) {
      state.rightDrawerReadOnly = value;
    },
    SET_TOKEN(state, value) {
      state.token = value;
      state.utente = "utente"; // TODO modificare in base alla login
    },
    SET_MODULI_LICENZA(state, value) {
      state.moduliLicenza = [...value];
      const bb = Buffer.from(JSON.stringify(state.moduliLicenza)).toString(
        "base64"
      );
      localStorage.setItem("moduli", bb);
    },
    CLEAR_MODULI_LICENZA(state) {
      state.moduliLicenza = [];
      // state.localModuliLicenza = []
    },
  },
});
